import React, { ReactElement, ChangeEvent, useState } from 'react';
import VerintIVAUI from '../../VerintIVAUI';

import { AlmeTheme, AlmeThemeMode, defaultTheme, defaultDarkTheme } from '../../models/AlmeTheme';

import { Container, MenuItem, Select, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles, ThemeProvider } from '@material-ui/core/styles';

import AlmeStyleTools from '../AlmeStyleTools/AlmeStyleTools';
import { createTheme } from '../../utils/PersonaUtils';
import AlmeLaunchTools from '../AlmeLaunchTools/AlmeLaunchTools';
import { AlmeIvaTypeProp } from "../../models/AlmeIvaTypeMapping";
import TestAlmePostMessageListener from "../TestAlmePostMessageListener/TestAlmePostMessageListener";

import { getRootIdByIvaType } from '../../indexConfig';
import { PersonaState } from '../../models/AlmePersona';
import { AlmeConfig } from '../../models/AlmeConfig';
import { LiveChatNotificationApiSettings } from '@alme/api-ts/LiveChat/LiveChatNotificationApiSettings';
import AlmeModuleVersion from './AlmeModuleVersion/AlmeModuleVersion';

interface AlmeTestPageProps {
    ivaType: AlmeIvaTypeProp;
    apiSettings: LiveChatNotificationApiSettings;
    personaState: PersonaState;
    setPersonaState: React.Dispatch<React.SetStateAction<PersonaState>>;
    personaMapped: React.MutableRefObject<boolean>;
    isIvaProLaunch?: React.MutableRefObject<boolean>;
    clearAppData: () => void;
}

const useStyles = makeStyles(({ palette, spacing }: Theme) =>
    createStyles({
        root: {
            border: `solid 1px ${palette.divider}`,
            padding: spacing(1),
        },
    }),
);

export default function AlmeTestPage(props: AlmeTestPageProps): ReactElement {
    const classes = useStyles();

    const [ivaType, setIvaType] = useState<AlmeIvaTypeProp>('embedded');
    const handleChange = (event: ChangeEvent<{ value: unknown }>) => {
        changeContainerDiv(ivaType, event.target.value as AlmeIvaTypeProp);
        setIvaType(event.target.value as AlmeIvaTypeProp);

    };

    const changeContainerDiv = (currentIvaType: AlmeIvaTypeProp, newIvaType: AlmeIvaTypeProp) => {
        const curContainer = document.getElementById(getRootIdByIvaType(currentIvaType));
        if(curContainer && curContainer.id) {
            curContainer.id = getRootIdByIvaType(newIvaType);
        }
    };

    const setAppTheme = (theme: AlmeTheme) => {
        props.setPersonaState({
            ...props.personaState,
            theme,
        });
    };

    const setThemeMode = (themeMode: AlmeThemeMode) => {
        props.setPersonaState({
            ...props.personaState,
            themeMode,
        });
    };

    const setConfig = (config: AlmeConfig) => {
        props.setPersonaState({
            ...props.personaState,
            config,
        });
    };

    const appTheme = props.personaState.themeMode === 'dark' ?
        createTheme([defaultDarkTheme, props.personaState.theme.darkTheme]) :
        createTheme([defaultTheme, props.personaState.theme.lightTheme]);

    return (
        <ThemeProvider theme={appTheme}>
            <div id='alme-test-container'>
                <Typography variant="h1" >Verint Material UI</Typography>
                <AlmeLaunchTools almeConfig={props.personaState.config}></AlmeLaunchTools>
                <br />
                <AlmeStyleTools
                    theme={props.personaState.theme} themeMode={props.personaState.themeMode} almeConfig={props.personaState.config}
                    setTheme={setAppTheme} setThemeMode={setThemeMode} setConfig={setConfig}></AlmeStyleTools>
                <AlmeModuleVersion apiSettings={props.apiSettings} />
                <Container className={classes.root}>
                    <Typography variant='subtitle1'>IVA Type</Typography>
                    <Select
                        id="ivaType-select"
                        value={ivaType}
                        variant={"outlined"}
                        onChange={handleChange}
                    >
                        <MenuItem value={"embedded"}>Embedded</MenuItem>
                        <MenuItem value={"popup"}>Popup</MenuItem>
                        <MenuItem value={"inline"}>Inline</MenuItem>
                    </Select>
                </Container>
                <TestAlmePostMessageListener />
            </div>
            <div id={getRootIdByIvaType(ivaType)}>
                <VerintIVAUI personaState={props.personaState} apiSettings={props.apiSettings} ivaType={ivaType}
                    personaMapped={props.personaMapped} isIvaProLaunch={props.isIvaProLaunch} clearAppData={props.clearAppData} />
            </div>
        </ThemeProvider>
    );
}
